import React from 'react'
import Navbar from '../Components/Navbar'
import IntroImg from "../Components/IntroImg"
import Footer from "../Components/Footer"
const Home = () => {
  return (
    <div>
        <Navbar/>
        <IntroImg />
        <Footer/>
    </div>
  )
}

export default Home